import type { Ora } from "ora";

import { inspect } from "node:util";

import { bold, cyan, gray } from "colorette";
import ora from "ora";

import { box } from "@/src/utils/box.ts";
import { highlighter } from "@/src/utils/highlighter.ts";

let debugModeActive = false;
let spinner: Ora;

export const messageToString = (debug: unknown): string => {
  if (typeof debug === "string") {
    return debug;
  }
  return inspect(debug);
};

export const logger = {
  setDebugModeTo(toggle: boolean) {
    debugModeActive = toggle;
  },
  error(...args: unknown[]) {
    console.log(
      highlighter.error(args.map((m) => messageToString(m)).join(" ")),
    );
  },
  warn(...args: unknown[]) {
    console.log(highlighter.warn(args.join(" ")));
  },
  info(...args: unknown[]) {
    console.log(highlighter.info(args.join(" ")));
  },
  success(...args: unknown[]) {
    console.log(highlighter.success(args.join(" ")));
  },
  log(...args: unknown[]) {
    console.log(args.join(" "));
  },
  box(...args: Parameters<typeof box>) {
    console.log(box(...args));
  },
  resetSpinner() {
    spinner = ora({
      interval: 40,
      spinner: "dots",
    });
  },
  spinner() {
    if (!spinner) {
      this.resetSpinner();
    }
    return spinner;
  },
  debug(debug: unknown) {
    if (debugModeActive) {
      if (!spinner) {
        this.resetSpinner();
      }

      const spinnerText = spinner.text;
      const wasSpinning = spinner.isSpinning;
      if (wasSpinning) {
        spinner.stop();
        this.log(`${cyan("⠴")} ${spinnerText}`);
      }

      console.log(
        `${bold("[debug]")} ${gray(
          `[${new Date().toISOString()}]`,
        )} ${messageToString(debug)}`,
      );

      if (wasSpinning) {
        spinner.start(spinnerText);
      }
    }
  },
  break() {
    console.log("");
  },
};
